import React from 'react';
import { Box, Text } from 'ink';
import { useTheme } from '../../lib/theme';
import type { ThemeTokens } from '../../lib/theme';
import { BaseTool } from './BaseTool';
import type { ToolComponentProps, TodoWriteInput } from './types';

type TodoStatus = TodoWriteInput['todos'][number]['status'];

const STATUS_ICON: Record<TodoStatus, string> = {
  pending: '○',
  in_progress: '◎',
  completed: '●',
  cancelled: '⊘',
};

const statusColor = (tokens: ThemeTokens, status: TodoStatus): string =>
  ({
    pending: tokens.text.subtle,
    in_progress: tokens.text.warning,
    completed: tokens.text.success,
    cancelled: tokens.text.subtle,
  })[status];

export const TodoWriteTool: React.FC<ToolComponentProps<TodoWriteInput>> = ({
  input,
  state,
  expanded,
}) => {
  const { tokens } = useTheme();
  return (
    <BaseTool label="Todos" state={state} expanded={expanded}>
      <Box flexDirection="column" paddingLeft={2}>
        {input.todos.map((todo, i) => (
          <Box key={`${todo.status}-${i}`} gap={1}>
            <Text color={statusColor(tokens, todo.status)}>{STATUS_ICON[todo.status]}</Text>
            <Text
              strikethrough={todo.status === 'cancelled'}
              dimColor={todo.status === 'cancelled' || todo.status === 'completed'}
            >
              {todo.description}
            </Text>
          </Box>
        ))}
      </Box>
    </BaseTool>
  );
};
